var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.58 21c.876 0 1.642-.257 2.3-.77.656-.513 1.085-1.195 1.286-2.047l.986-4.487c.091-.348.05-.679-.123-.992A1.722 1.722 0 0019.33 12c.365-.14.699-.365 1-.678.3-.313.497-.644.588-.992l.986-4.513c.2-.852.087-1.534-.342-2.047-.43-.513-1.09-.77-1.985-.77H5.997L2 21h13.58zm-1.096-10.122h-3.942l1.26-5.608h3.942l-1.26 5.608zm-1.752 7.879H8.79l1.26-5.635h3.942l-1.26 5.635z",
    fill: "#CAFCFF",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmaker);
export default __webpack_public_path__ + "static/media/bookmaker.0752d77ee852b5a94b35d021fc0e1be2.svg";
export { ForwardRef as ReactComponent };